import { querySteps } from "@/mocks/home";

export default function QuerySteps() {
  return (
    <section id="query" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            Query Steps
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            四步完成一次规范的资源查询
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            不论你习惯用百度云还是磁力链接，检索的逻辑其实是一致的。按下面的顺序走一遍，能明显减少无效尝试与误入陌生页面的风险。
          </p>
        </div>

        <div className="mt-10 flex flex-col lg:flex-row gap-8">
          <ol className="flex-1 space-y-4">
            {querySteps.map((item, index) => (
              <li key={item.step} className="relative flex gap-4 md:gap-5">
                <div className="flex flex-col items-center">
                  <span className="w-11 h-11 shrink-0 rounded-full bg-primary-500 text-background-50 font-heading font-bold flex items-center justify-center">
                    {item.step}
                  </span>
                  {index < querySteps.length - 1 && (
                    <span className="w-px flex-1 my-2 bg-background-300"></span>
                  )}
                </div>
                <div className="pb-2">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {item.tips.map((tip) => (
                      <span
                        key={tip}
                        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium"
                      >
                        <i className="ri-lightbulb-line"></i>
                        {tip}
                      </span>
                    ))}
                  </div>
                </div>
              </li>
            ))}
          </ol>

          <div className="lg:w-[42%] shrink-0">
            <div className="rounded-lg overflow-hidden border border-background-200">
              <div className="w-full h-56 md:h-72">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20minimal%20illustration%20of%20interconnected%20cloud%20storage%20nodes%20and%20download%20arrows%20network%20on%20warm%20cream%20background%2C%20vermilion%20and%20amber%20geometric%20shapes%2C%20clean%20editorial%20tech%20poster%20style%2C%20soft%20gradients%2C%20no%20text&width=1200&height=900&seq=secretary-query-flow&orientation=landscape"
                  alt="资源查询流程示意图"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="bg-background-100 p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                  查询时最容易忽略的一点
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  先确认内容的合法来源，再决定是否保存或下载。任何要求你输入账号密码、短信验证码或付款信息的「解锁」页面，
                  都应当直接关闭。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}